<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        网站内容共享协议: <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.zh">署名-非商业性使用-相同方式共享 4.0 国际 (CC
        BY-NC-SA 4.0)</a>
      </p>
      <p>Github: <a href="https://github.com/lie-flat/cfps-report">https://github.com/lie-flat/cfps-report</a></p>
      <p>数据分析代码：<a href="https://github.com/lie-flat/cfps-analyze/tree/master/nbs">https://github.com/lie-flat/cfps-analyze/tree/master/nbs</a>
      </p>
      <p>部分讲解幻灯片：<a href="https://github.com/lie-flat/slides">https://github.com/lie-flat/slides</a></p>
      <p class="subtitle is-5">友情链接</p>
      <p>kxxt 的个人网站：<a href="https://kxxt.vercel.app">https://kxxt.vercel.app</a></p>
    </div>
  </footer>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "Footer",

});
</script>

<style scoped>

</style>